<template>
  <div class="col-4 d-flex">
    <div class="card dimension-card w-100">
      <div class="card-body d-flex flex-column">
        <div class="d-flex align-items-start justify-content-between mb-2">
          <div v-if="option.title" class="option__name">{{ option.title }}</div>
          <div class="tooltip-box text-end ms-auto">
            <tooltip-btn v-if="option.tooltip && option.tooltip.image" :tooltip="option.tooltip" />
            <Tooltip v-else-if="option.tooltip && option.tooltip.text" :tooltip="option.tooltip">
              <button type="button" class="btn-reset btn-tooltip">
                <i class="fas fa-info-circle"></i>
              </button>
            </Tooltip>
          </div>
        </div>
        <div class="dimension-card__image">
          <img :src="$filters.image(option.image, '350x')" alt="">
        </div>
        <div v-if="option.description" class="description mb-2" v-html="option.description"></div>
        <select class="form-select mt-auto" @change="onChange">
          <option v-for="(selectOption, index) in selectOptions" :value="selectOption.value" :selected="selectOption.selected" :key="index">{{ selectOption.label }}</option>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, toRefs } from '@vue/reactivity'
import { useStore } from 'vuex'
import TooltipBtn from '@/pages/configurator/common/tooltipBtn.vue'
export default {
  name: 'DimensionOption',
  components: {
    TooltipBtn
  },
  props: {
    type: {
      require: true,
      type: String
    },
    option: {
      require: true,
      type: Object
    },
    optionDim: {
      require: true,
      type: Object
    },
    heightMax: {
      require: false,
      type: Number,
      default: 0
    },
    values: {
      require: false,
      type: Array,
      default: () => []
    }
  },
  setup (props) {
    const store = useStore()
    const heightMax = toRefs(props).heightMax
    const optionDim = toRefs(props).optionDim
    const type = toRefs(props).type
    const explicitValues = toRefs(props).values
    const selectOptions = computed(() => {
      if (Array.isArray(explicitValues.value) && explicitValues.value.length) {
        return explicitValues.value.map(value => ({
          value,
          label: `${value} ${optionDim.value.unit}`,
          selected: Number(optionDim.value.value) === Number(value)
        }))
      }
      const values = []
      const maxDim = (type.value === 'height' && heightMax.value > 0) ? heightMax.value : optionDim.value.max
      for (let i = Number.parseInt(optionDim.value.min); i <= Number.parseInt(maxDim); i += optionDim.value.step) {
        values.push({
          value: i,
          label: `${i} ${optionDim.value.unit}`,
          selected: optionDim.value.value === i
        })
      }
      return values
    })
    function onChange (e) {
      store.dispatch('system/setDimensionBase', {
        type: type.value,
        value: e.target.value
      })
    }
    return {
      selectOptions,
      onChange
    }
  }
}
</script>
<style scoped>
.dimension-card__image {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 220px;
  margin-bottom: 12px;
}
.dimension-card__image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>
